import { Select } from 'formik-antd';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { IntlMessages } from '@/components';
import { countries } from '@/const/countries';
import makeSelectFilterOption from '@/lib/makeSelectFilterOption';
import styles from './CountrySelector.module.css';

const CountrySelector = ({
  name = null,
  placeholder = null,
  isDisabledSelectAll = false,
  onSelectAll = () => {},
  disabled = false,
  isView = false,
  setFieldValue = (_key, _value) => {},
  setFieldTouched = (_key, _value) => {},
}) => {
  return (
    <div className="hp-d-flex">
      <Select
        allowClear
        showSearch={{
          filterOption: (input, option) => makeSelectFilterOption(option?.label ?? '', input),
        }}
        mode="multiple"
        maxTagCount="responsive"
        className="single-line-select"
        name={name}
        onClear={async () => {
          await setFieldTouched(`${name}`, true);
        }}
        placeholder={placeholder}
        disabled={disabled}
        options={countries}
        onChange={async (value) => {
          await setFieldValue(`${name}`, value.sort());
        }}
      />
      {!isView && (
        <Button className={styles.selectAll} disabled={isDisabledSelectAll} onClick={onSelectAll}>
          <IntlMessages id="ui-general-select-all" />
        </Button>
      )}
    </div>
  );
};

CountrySelector.propTypes = {
  name: PropTypes.string.isRequired,
  isDisabledSelectAll: PropTypes.bool.isRequired,
  placeholder: PropTypes.any.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isView: PropTypes.bool,
};

export default CountrySelector;
